import { Box, Grid, Typography } from "@mui/material";
import logo from "../assets/logo.png"
import BATextarea from "../config/components/BATextarea";
import BAInput from "../config/components/BAInput";
import BAIconbutton from "../config/components/BAIconbutton";
import StarRateIcon from '@mui/icons-material/StarRate';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { useState } from "react";
import BAButton from "../config/components/BAButton";
import { Post } from "../config/apimethods/apimethods";
import BAShowError from "../config/components/BAShowerror";

export default function FeedbackForm() {
    const [model, setModel] = useState({
    });
    const [ratings, setRatings] = useState([1, 2, 3, 4, 5])
    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false);
    const [property, setProperty] = useState({
        message: "",
        open: false,
    });

    const markRate = (rate) => {
        setModel({ ...model, starRating: rate })
    }

    const submitReview = () => {
        let reqArr = ["customerName", "starRating", "comments"];
        let errArr = []
        reqArr.forEach((x) => {
            if (!model[x]) {
                errArr.push(`Required ${x}`)
            }
        })

        if (errArr.length > 0) {
            setProperty({ ...property, open: true, message: errArr })
            return
        }


        setLoading(true)
        Post('feedback', model)
            .then((res) => {
                setProperty({ ...property, message: "Your feedback has been submitted.", open: true })
                setModel({ ...model })
                setLoading(false)
                setSubmitted(true)
            }).catch((err) => {
                setProperty({ ...property, message: err.response?.data?.message || err.response?.data?.error || err.message, open: true })
                setLoading(false)
            });
    }
    const handleErrorClose = () => {
        setProperty({ ...property, open: false })
    }

    return <>
        <BAShowError message={property.message} open={property.open} close={handleErrorClose} />
        <Box>
            <Box sx={{ backgroundColor: '#264653' }} className="py-5 text-white">
                <Box className="container d-flex">
                    <img src={logo} width={100} alt="Mubashir Curtain" />
                    <Box className="ps-2">
                        <Typography className="fs-1">Feedback</Typography>
                        <Typography className="fs-5">Your Feedback motivate us to improve Quality</Typography>
                    </Box>
                </Box>
            </Box>
            <Box className="p-2 py-5 container">
                {submitted ? <Box className="p-3">
                    <Typography sx={{ color: "#191919" }} className="fs-2">Thank You! for your valueable Feedback</Typography>
                </Box> : <Grid container spacing={2}>
                    <Grid item md={6} sm={12} xs={12}>
                        <Box className="p-3">
                            <Box className="mb-3">
                                <BAInput
                                    value={model.customerName}
                                    onChange={(e) => {
                                        setModel({ ...model, customerName: e.target.value })
                                    }}
                                    label="Customer Name"
                                />
                            </Box>
                            <Box className="mb-3">
                                <BATextarea
                                    value={model.comments}
                                    onChange={(e) => {
                                        setModel({ ...model, comments: e.target.value })
                                    }}
                                    rows={6}
                                    label='Comments'
                                />
                            </Box>
                            <Box className="mb-3">
                                <Typography>Rate the Service</Typography>
                                {ratings.map((x, i) => <BAIconbutton onClick={() => markRate(x)} key={i} icon={x <= model.starRating ? <StarRateIcon /> : <StarBorderIcon />} />)}
                            </Box>
                            <Box className="py-3">
                                <BAButton loading={loading} onClick={submitReview} fullWidth={true} label='Submit Reviews' />
                            </Box>
                        </Box>
                    </Grid>

                </Grid>}
            </Box>
        </Box>
    </>
}